import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { api } from "@/services/api.ts";

/** Per-environment switches from the BFF, read once per session after sign-in. */
export function useFeatures() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ["features"],
    queryFn: () => api.features.get(),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: isAuthenticated,
  });
}
